import { LocationModel } from "../../../models/container_master_model/location";
import { ServiceMasterModel } from "src/app/models/common/service-master.model";
import { PhoneModel } from "src/app/models/common/phone-model";
import { IRequirementsModel, RequirementError, RequirementsModel } from "../../one-way-data/request/requirements-model";
import { ExternalMyTeamModel } from "src/app/components/master-data/user-form-external/external-my-team.model";

export interface ILeadRequestModel {
    id?: string;
    pol_list: string[];
    pod_list: string[];
    request_type: string;
    transaction_type: string;
    email: string;
    request_source: string;
    mobile: string;
    token?: string;
    requirements?: IRequirementsModel[];
    csc_revalidation_required?: boolean;

    is_active?: boolean;
    created_at?: Date;
    created_by?: string;
    updated_at?: Date;
    updated_by?: string;
    invite?: ExternalMyTeamModel;
}

export interface LeadRequestError {
    pol_list: string[];
    pod_list: string[];
    request_type: string[];
    transaction_type: string[];
    email: string[];
    mobile: string[];
    requirements: RequirementError[];
    csc_revalidation_required: string[];
}

export class LeadRequestModel {
    id?: string;
    pol_list: LocationModel[];
    pod_list: LocationModel[];
    request_type: ServiceMasterModel;
    transaction_type: string;
    email: string;
    request_source: string;
    mobile: PhoneModel;
    token?: string;
    requirements?: RequirementsModel[];
    csc_revalidation_required?: boolean;

    // fields required for LeadVerification and LeadTable component
    is_active?: boolean;
    created_at?: Date;
    created_by?: string;
    updated_at?: Date;
    updated_by?: string;
    invite?: ExternalMyTeamModel;

    error: LeadRequestError;

    constructor() {
        this.pol_list = [];
        this.pod_list = [];
        this.request_type = null;
        this.transaction_type = null;
        this.request_source = 'Customer Portal';
        this.mobile = null;
        this.requirements = [new RequirementsModel()];
        this.csc_revalidation_required = true;

        this.resetErrors();
    }

    resetErrors() {
        this.error = {
            pol_list: [],
            pod_list: [],
            request_type: [],
            transaction_type: [],
            email: [],
            mobile: [],
            requirements: [new RequirementError()],
            csc_revalidation_required: [],
        }

        for (let i = 0; i < this.requirements.length; i++) {
            this.error.requirements[i] = new RequirementError();
        }
    }

    patchErrors(errors) {
        this.error.pol_list = errors != null && errors.pol_list ? errors.pol_list : [];
        this.error.pod_list = errors != null && errors.pod_list ? errors.pod_list : [];
        this.error.request_type = errors != null && errors.request_type ? errors.request_type : [];
        this.error.transaction_type = errors != null && errors.transaction_type ? errors.transaction_type : [];
        this.error.email = errors != null && errors.email ? errors.email : [];
        this.error.mobile = errors != null && errors.mobile ? errors.mobile : [];
        this.error.csc_revalidation_required = errors != null && errors.csc_revalidation_required ? errors.csc_revalidation_required : [];

        this.error.requirements = errors != null && errors.requirements?.length ? errors.requirements : [new RequirementError()];
    }

    is_valid() {
        this.resetErrors();



        if (this.request_type == null) {
            this.error.request_type.push('Please select a request type');
        }

        if (this.transaction_type == null && this.request_type.dev_name != 'lease') {
            this.error.transaction_type.push('Please select a transaction type');
        }

        if (this.email == null || this.email == '') {
            this.error.email.push('Please enter an email to continue');
        }

        if (this.mobile == null) {
            this.error.mobile.push('Please enter mobile number to continue');
        }

        if (this.pol_list.length < 1) {
            this.error.pol_list.push('Please select at least one Port');
        }

        if (this.request_type.dev_name != 'buy_sell') {
            if (this.pod_list.length < 1) {
                this.error.pod_list.push('Please select at least one Port');
            }
        }

        let reqError: boolean = false;
        let tempErr: boolean;
        for (let i = 0; i < this.requirements.length; i++) {
            if (this.request_type.dev_name == 'one_way') {
                tempErr = this.error.requirements[i].is_oneway_requirement_valid(this.requirements[i]);
                reqError = reqError ? reqError : tempErr;
            }
            if (this.request_type.dev_name == 'buy_sell') {
                tempErr = this.error.requirements[i].is_trade_requirement_valid(this.requirements[i]);
                reqError = reqError ? reqError : tempErr;
            }
            if (this.request_type.dev_name == 'lease') {
                tempErr = this.error.requirements[i].is_lease_requirement_valid(this.requirements[i]);
                reqError = reqError ? reqError : tempErr;
            }
        }

        return this.error.request_type.length == 0 &&
            this.error.transaction_type.length == 0 &&
            this.error.email.length == 0 &&
            this.error.mobile.length == 0 &&
            this.error.pol_list.length == 0 &&
            this.error.pod_list.length == 0 && reqError
    }

    getLeadRequestData() {
        if (this.request_type.dev_name == 'one_way') {
            return {
                request_type: this.request_type.id,
                transaction_type: this.transaction_type,
                pol_list: this.pol_list.map((item) => item.id),
                pod_list: this.pod_list.map((item) => item.id),
                request_source: this.request_source,
                requirements: this.requirements.map((item) => item.getOneWayRequirementPayload()),
                email: this.email,
                mobile: this.mobile.as_e164,
            }
        }
        if (this.request_type.dev_name == 'buy_sell') {
            return {
                request_type: this.request_type.id,
                transaction_type: this.transaction_type,
                pol_list: this.pol_list.map((item) => item.id),
                pod_list: this.pod_list.map((item) => item.id),
                request_source: this.request_source,
                requirements: this.requirements.map((item) => item.getTradeRequirementPayload()),
                email: this.email,
                mobile: this.mobile.as_e164,
                csc_revalidation_required: this.csc_revalidation_required,
            }
        }
        if (this.request_type.dev_name == 'lease') {
            return {
                request_type: this.request_type.id,
                transaction_type: this.transaction_type,
                pol_list: this.pol_list.map((item) => item.id),
                pod_list: this.pod_list.map((item) => item.id),
                request_source: this.request_source,
                requirements: this.requirements.map((item) => item.getLeaseRequirementPayload()),
                email: this.email,
                mobile: this.mobile.as_e164,
            }
        }
    }

    getDetailUrl(requestType) {
        switch (requestType) {
            case 'lease':
                return '/web-request/lead-request/lease-details';

            case 'one_way':
                return '/web-request/lead-request/one-way-details'

            case 'buy_sell':
                return '/web-request/lead-request/trading-details';

            default:
                return null;
        }
    }

    saveLeadPayloadToModel(data: LeadRequestModel) {
        if (data.request_type.dev_name == 'lease') {
            this.id = data.id;
            this.request_type = data.request_type;
            this.transaction_type = data.transaction_type;
            this.pol_list = data.pol_list;
            this.pod_list = data.pod_list;
            this.request_source = data.request_source;
            this.email = data.email;
            this.mobile = data.mobile;
            this.requirements = data.requirements.map((item) => new RequirementsModel(item));
        }
        if (data.request_type.dev_name == 'one_way') {
            this.id = data.id;
            this.request_type = data.request_type;
            this.transaction_type = data.transaction_type;
            this.pol_list = data.pol_list;
            this.pod_list = data.pod_list;
            this.request_source = data.request_source;
            this.email = data.email;
            this.mobile = data.mobile;
            this.requirements = data.requirements.map((item) => new RequirementsModel(item));
        }
        if (data.request_type.dev_name == 'buy_sell') {
            this.id = data.id;
            this.request_type = data.request_type;
            this.transaction_type = data.transaction_type;
            this.pol_list = data.pol_list;
            this.pod_list = data.pod_list;
            this.request_source = data.request_source;
            this.email = data.email;
            this.mobile = data.mobile;
            this.csc_revalidation_required = data.csc_revalidation_required;
            this.requirements = data.requirements.map((item) => new RequirementsModel(item));
        }
    }

}
